import { useQuery } from 'react-query';

import { getQuotes } from '../../api/homeServices/utils/getQuotes';
import { GetQuotesResponse } from '@/src/api/homeServices/types';

export const useBoilerQuote = (needsRepair: boolean, isAbs?: boolean) => {
  return useQuery<GetQuotesResponse>(
    ['getQuote', needsRepair, isAbs],
    () => getQuotes(needsRepair, isAbs),
    {
      cacheTime: 10 * 60 * 1000,
      staleTime: 10 * 60 * 1000,
      retry: 1,
      keepPreviousData: true,
      refetchOnMount: true,
      refetchOnReconnect: true,
      refetchOnWindowFocus: false,
    },
  );
};
